import { Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { AuthService } from '../../../service/auth-service/auth-service.service';
import { Art57NodeList } from '../../../ui/Node/Art57Node/Art57NodeList';
import { QueryNode } from '../../../ui/Node/QueryNode';
import { QueryResultNode } from '../../../ui/Node/QueryResultNode';
import { ResultList } from '../../../ui/Node/ListEntity/ResultList';
import { SimpleSearchListNode } from '../../../ui/Node/SimpleSearchListNode';
import { QueryConditionsNode } from '../../../ui/Node/QueryConditionsNode';
import { BaseNode } from '../../../ui/Node/BaseNode';
import { QueryFieldsNode } from '../../../ui/Node/QueryFieldsNode';
import { Art57NodeUtils } from '../../../ui/Node/Art57Node/Art57NodeUtils';
import { Art57Section } from '../../../ui/Art57Section/Art57Section';
import { AutoUploadNode } from '../../../ui/Node/AutoUploadNode';
import { MedicinalProductsQueryResultNode } from '../../../ui/Node/MedicinalProductsNode/MedicinalProductsQueryResultNode';
import { SectionService } from '../../../service/section-service/section-service';
import { MedicinalProductsQueryNode } from '../../../ui/Node/MedicinalProductsNode/MedicinalProductsQueryNode';
import { MedicinalProductsNodeUtils } from '../../../ui/Node/MedicinalProductsNode/MedicinalProductsNodeUtils';
import { MedicinalproductsService } from '../../../service/medicinalproducts-service/medicinalproducts.service';
import { environment } from '../../../../../environments/environment';
import { CheckedManagement } from '../../../ui/CheckedManagement';
import { ApprovedSubstanceAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/ApprovedSubstanceAutoUploadEntity';
import { AttachmentAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/AttachmentAutoUploadEntity';
import { AttachmentQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/Attachment/AttachmentQueryNode';
import { AuthorisedProductAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/AuthorisedProductAutoUploadEntity';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DiffViewerComponent } from '../../diff-viewer/diff-viewer/diff-viewer.component';
import { DevelopmentProductAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/DevelopmentProductAutoUploadEntity';
import { DevelopmentSubstanceAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/DevelopmentSubstanceAutoUploadEntity';
import { SourceAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/SourceAutoUploadEntity';
import { ApprovedSubstancesQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/ApprovedSubstances/ApprovedSubstancesQueryNode';
import { DevelopmentSubstanceQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/DevelopmentSubstances/DevelopmentSubstanceQueryNode';
import { SourceQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/Source/SourceQueryNode';
import { MedicinalProductsSimpleQueryNode } from '../../../ui/Node/MedicinalProductsNode/MedicinalProductsSimpleQueryNode';
import { SubstanceNamesQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/SubstanceNames/SubstanceNamesQueryNode';
import { OwnedAuthorisedProductsQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/AuthorisedProducts/OwnedAuthorisedProductsQueryNode';
import { AuthorisedProductsValidVersionQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/AuthorisedProducts/AuthorisedProductsValidVersionQueryNode';
import { OwnedDevelopmentProductsQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/DevelopmentProducts/OwnedDevelopmentProductsQueryNode';
import { TreeNodeMedicinalProductsAuthorisedProduct } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsAuthorisedProduct';
import { AuthorisedProductsLastVersionQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/AuthorisedProducts/AuthorisedProductsLastVersionQueryNode';
import { OwnedEVMPDEntitiesQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/OwnedEVMPDEntities/OwnedEVMPDEntitiesQueryNode';
import { OwnedByEVMPDEntitiesQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/OwnedEVMPDEntities/OwnedByEVMPDEntitiesQueryNode';
import { TreeNodeMedicinalProductsDevelopmentProduct } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsDevelopmentProduct';
import { AbstractCompositionsAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/AbstractCompositionsAutoUploadEntity';
import { TreeNodeMedicinalProductsAbstractCompositions } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsAbstractCompositions';
import { AbstractCompositionQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/AbstractComposition/AbstractCompositionQueryNode';
import { OnDemandAutoUploadNode } from '../../../ui/Node/MedicinalProductsNode/OnDemandAutoUploadNode';
import { OnDemandSimpleSearchListNode } from '../../../ui/Node/OnDemandSimpleSearchListNode';
import { DevelopmentProductsLastVersionQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/DevelopmentProducts/DevelopmentProductsLastVersionQueryNode';
import { DevelopmentProductsValidVersionQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/DevelopmentProducts/DevelopmentProductsValidVersionQueryNode';
import { MedicinalProductComponent } from '../../../../sections/medicinalProduct/medicinal-product/medicinal-product.component';
import { ConfirmationService } from 'primeng/api';
import { TYPE_DICTIONARY, TYPE_DICTIONARY_LABEL } from '../../../ui/Constants';
import { MAHsQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/MAHs/MAHsQueryNode';
import { SponsorQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/Sponsor/SponsorQueryNode';
import { MAHAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/MAHAutoUploadEntity';
import { SponsorAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/SponsorAutoUploadEntity';
import { AssessmentResultSummaryInfo } from '../../../ui/Data/Assessment/AssessmentResultInfo';
import { TreeNodeMedicinalProductsXevprmMessage } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsXevprmMessage';
import { ValidationQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/Validation/ValidationQueryNode';
import { XevprmMessageAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/XevprmMessageAutoUploadEntity';
import { MessageQueryNode } from '../../../ui/Node/MedicinalProductsNode/Query/Message/MessageQueryNode';
import { ATCcodeAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/ATCcodeAutoUploadEntity';
import { ROAAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/ROAAutoUploadEntity';
import { PharmaceuticalFormAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/PharmaceuticalFormAutoUploadEntity';
import { MFLAutoUploadEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/MFLAutoUploadEntity';
import { TreeNodeMedicinalProductsApprovedSubstance } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsApprovedSubstance';
import { TreeNodeMedicinalProductsDevelopmentSubstance } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsDevelopmentSubstance';
import { TreeNodeMedicinalProductsSource } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsSource';
import { TreeNodeMedicinalProductsMAH } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsMAH';
import { TreeNodeMedicinalProductsSponsor } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsSponsor';
import { TreeNodeMedicinalProductsATCcode } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsATCcode';
import { TreeNodeMedicinalProductsROA } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsROA';
import { TreeNodeMedicinalProductsPharmaceuticalForm } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsPharmaceuticalForm';
import { TreeNodeMedicinalProductsMFL } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsMFL';
import { TreeNodeMedicinalProductsAttachment } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsAttachment';
import { TreeNodeMedicinalProductsPreviousProductVersion } from '../../../ui/Node/MedicinalProductsNode/ListEntity/TreeNodeMedicinalProductsPreviousProductVersion';

@Component({
  selector: 'app-medicinal-product-toolbox',
  templateUrl: './medicinal-product-toolbox.component.html',
  styleUrl: './medicinal-product-toolbox.component.scss'
})
export class MedicinalProductToolboxComponent {
  @Input() selectedNode: any;
  @Output() buttonAction = new EventEmitter();
  modalRef!: BsModalRef;
  sortOrder: boolean = true;
  pageSizes: any = [
    { value: 25 },
    { value: 50 },
    { value: 100 },
    { value: 200 }
  ];

  constructor(public authService: AuthService,
    private modalService: BsModalService,
    private injector: Injector) {
  }

  operate(node: any, operation: number) {

    let nodeWithParams = node;
    let model = node.data.model;

    if (node instanceof MedicinalProductsQueryResultNode) {
      nodeWithParams = Art57NodeUtils.findFirstParentNodeOfType(node, MedicinalProductsQueryNode);
      model = node.data.model.filter((i: any) => i.checked && i.checked === true);
      if (model.length === 0) {
        this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'No items checked', life: environment.warningElapsedTime });
        return;
      }
    }


    if (operation === 6 && !(this.selectedNode.parent instanceof TreeNodeMedicinalProductsAuthorisedProduct) && !this.selectedNode.parent.parent) {
      this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'The operation cannot be performed on entity  with EV code ' + model.ev_Code, life: environment.successElapsedTime });
    } else if (operation === 6 && !(this.selectedNode.parent.parent instanceof AuthorisedProductsValidVersionQueryNode) && !(this.selectedNode.parent.parent instanceof AuthorisedProductsLastVersionQueryNode) && !(this.selectedNode.parent.parent instanceof OwnedAuthorisedProductsQueryNode) && this.selectedNode.parent.parent) {
      model.forEach((element: any) => {
        this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'The operation cannot be performed on entity  with EV code ' + element.ev_Code, life: environment.successElapsedTime });
      });
    } else {
      if (operation === 1) {
        this.injector.get(Art57Section).medicinalProduct.reinsertInfo().then(result => {
          if (result === true) {
            setTimeout(() => {
              MedicinalProductsNodeUtils.createXEVPRMNode(operation, nodeWithParams, model);
            }, 0);
          }
        });
      } else {
        setTimeout(() => {
          MedicinalProductsNodeUtils.createXEVPRMNode(operation, nodeWithParams, model);
        }, 0);
      }
    }
  }

  onButtonAction(buttonAction: String, parameter: any) {
    switch (buttonAction) {
      case 'selectAll':
        CheckedManagement.manageItemChecked(parameter, true);
        break;
      case 'deselectAll':
        CheckedManagement.manageItemChecked(parameter, false);
        break;
      case 'loadSelected':
        this.onloadSelected(parameter);
        break;
      case 'loadDynamicEntity':
        this.onloadDynamicEntity(parameter);
        break;
      case 'operate':
        this.operate(parameter.node, parameter.operation);
        break;
      case 'exportMultiRTF':
        this.export(parameter, true, 'rtf');
        break;
      case 'exportSingleRTF':
        this.export(parameter, false, 'rtf');
        break;
      case 'exportSingleXML':
        this.export(parameter, false, 'xml');
        break;
      case 'exportMultiXML':
        this.export(parameter, true, 'xml');
        break;
      case 'compare':
        this.compare(parameter.node, parameter.type);
        break;
      case 'sortField':
        this.sortField(parameter);
        break;
      case 'assess':
        this.assess(parameter.node, parameter.type);
        break;
      default:
        const data = { action: buttonAction, param: parameter };
        this.buttonAction.emit(data);
    }
  };


  onloadSelected(node: BaseNode) {
    this.injector.get(Art57Section).medicinalProduct.loadSelectedEntityNode(node);
  }

  onLoadAutouploadNode(node: AutoUploadNode) {
     let simpleSearchListNode = undefined;
    if (node instanceof AuthorisedProductAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.authorisedProductTreeNode;
    } else if (node instanceof DevelopmentProductAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.developmentProductTreeNode;
    } else if (node instanceof ApprovedSubstanceAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.approvedSubstanceTreeNode;
    } else if (node instanceof DevelopmentSubstanceAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.developmentSubstanceTreeNode;
    } else if (node instanceof SourceAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.sourceTreeNode;
    } else if (node instanceof MAHAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.mahsTreeNode;
    } else if (node instanceof SponsorAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.sponsorTreeNode ;
    } else if (node instanceof ATCcodeAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.atccodeTreeNode ;
    } else if (node instanceof ROAAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.roaTreeNode ;
    } else if (node instanceof PharmaceuticalFormAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.pharmaceuticalFormTreeNode ;
    } else if (node instanceof MFLAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.masterfilelocationTreeNode ;
    } else if (node instanceof AttachmentAutoUploadEntity) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.attachmentTreeNode ;
    }
    let newChild: any = simpleSearchListNode?.children?.find((child: any) => child.data.model.id === node.data.model.id);

    if (newChild == undefined && simpleSearchListNode) {
      newChild = node.cloneNode(simpleSearchListNode);
      simpleSearchListNode?.children?.push(newChild);
    }

    node.ioc!.get(SectionService).selectMedicinalProductsNode(newChild);

  }

  onLoadSimpleSearchListNode(node: SimpleSearchListNode) {
     let simpleSearchListNode = undefined;
    if (node instanceof TreeNodeMedicinalProductsAuthorisedProduct) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.authorisedProductTreeNode;
    } else if (node instanceof TreeNodeMedicinalProductsDevelopmentProduct) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.developmentProductTreeNode;
    } else if (node instanceof TreeNodeMedicinalProductsApprovedSubstance) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.approvedSubstanceTreeNode;
    } else if (node instanceof TreeNodeMedicinalProductsDevelopmentSubstance) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.developmentSubstanceTreeNode;
    } else if (node instanceof TreeNodeMedicinalProductsSource) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.sourceTreeNode;
    } else if (node instanceof TreeNodeMedicinalProductsMAH) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.mahsTreeNode;
    } else if (node instanceof TreeNodeMedicinalProductsSponsor) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.sponsorTreeNode ;
    } else if (node instanceof TreeNodeMedicinalProductsATCcode) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.atccodeTreeNode ;
    } else if (node instanceof TreeNodeMedicinalProductsROA) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.roaTreeNode ;
    } else if (node instanceof TreeNodeMedicinalProductsPharmaceuticalForm) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.pharmaceuticalFormTreeNode ;
    } else if (node instanceof TreeNodeMedicinalProductsMFL) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.masterfilelocationTreeNode ;
    } else if (node instanceof TreeNodeMedicinalProductsAttachment) {
      simpleSearchListNode = this.injector.get(Art57Section).medicinalProduct.attachmentTreeNode ;
    }

    if (simpleSearchListNode != undefined){
      const checkedChildren = node.children?.filter(child => (child as BaseNode).checked) ?? [];

      if (checkedChildren.length === 0) {
        this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'No items checked', life: environment.warningElapsedTime });
        return;
      }

      checkedChildren.forEach(child => {
        if (simpleSearchListNode.children?.find(CurrentChild => (CurrentChild as AutoUploadNode).code == (child as AutoUploadNode).code)) {
            this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'Item already selected: ' + (child as BaseNode).labelTemplate, life: environment.warningElapsedTime });
        } else 
        {
          let newChild = (child as AutoUploadNode).cloneNode(simpleSearchListNode);
          simpleSearchListNode.children?.push(newChild!);
        }
      });

      if (simpleSearchListNode.children!.length > 0) {
        node.ioc!.get(SectionService).selectMedicinalProductsNode(simpleSearchListNode.children![0] as BaseNode);
      }
    }
  }

  onloadDynamicEntity(node: BaseNode) {
    if (node instanceof AutoUploadNode){
      this.onLoadAutouploadNode(node)
    } else if (node instanceof SimpleSearchListNode) {
      this.onLoadSimpleSearchListNode(node);
    }
 
  }

  isListView() {
    return this.selectedNode instanceof Art57NodeList;
  }

  isQueryNode() {
    return this.selectedNode instanceof QueryNode ||
      this.selectedNode.parent instanceof QueryNode;
  }

  isAbstractCompositionNode(){
    return this.selectedNode instanceof AbstractCompositionsAutoUploadEntity || this.selectedNode instanceof TreeNodeMedicinalProductsAbstractCompositions;
  }

  isAbstractCompositionQuery(){
    return this.selectedNode.parent && this.selectedNode.parent.parent && this.selectedNode.parent.parent instanceof AbstractCompositionQueryNode;
  }

  isResultNode() {
    return this.selectedNode instanceof QueryResultNode || this.selectedNode instanceof AbstractCompositionsAutoUploadEntity;
  }

  isSubstanceNamesNode() {
    return this.selectedNode.parent &&
      this.selectedNode.parent.parent &&
      this.selectedNode.parent.parent instanceof SubstanceNamesQueryNode;
  }

  getStatusAllQueryResultNode(selectedNode: BaseNode, checkvalue: boolean): boolean {
    let result = false;
    if (selectedNode.data.model) {
      const arrayModel = Object.values(selectedNode.data.model);
      result = arrayModel.some((item: any) => item.checked == checkvalue);
    }

    return result;
  }

  getStatusSimpleSearchListNode(selectedNode: SimpleSearchListNode, checkvalue: boolean): boolean {
    let result = false;
    if (selectedNode.data.model && selectedNode.showResults) {
      //working in array mode
      const arrayModel = Object.values(selectedNode.data.model);
      result = arrayModel.some((item: any) => item.checked == checkvalue);
    } else if (!selectedNode.showResults) {
      //working in tree mode
      result = selectedNode.children!.length > 0;
    }
    return result;
  }

  getStatusAllFieldsNode(selectedNode: BaseNode, checkvalue: boolean): boolean {
    let result = false;

    if (selectedNode.data.model) {
      const arrayModel = Object.entries(selectedNode.data.model).map(([key, value]) => {
        return { key, value };
      });

      result = arrayModel.some((item: any) => item.value == checkvalue);
    }

    return result;
  }

  isEnabledDeselectAll(selectedNode: BaseNode): boolean {
    let atLeastOneItemChecked = false;
    if (selectedNode instanceof QueryResultNode) {
      atLeastOneItemChecked = this.getStatusAllQueryResultNode(selectedNode, true);
    } else if (selectedNode instanceof QueryFieldsNode) {
      atLeastOneItemChecked = this.getStatusAllFieldsNode(selectedNode, true);
    } else if (selectedNode instanceof SimpleSearchListNode) {
      atLeastOneItemChecked = this.getStatusSimpleSearchListNode(selectedNode, true);
    } else if (selectedNode instanceof QueryConditionsNode) {
      atLeastOneItemChecked = selectedNode.data.model &&
        Object.keys(selectedNode.data.model).some(key => selectedNode.data.model[key] !== undefined && selectedNode.data.model[key] !== null && selectedNode.data.model[key] !== '');
    }
    return atLeastOneItemChecked;
  }

  isEnabledSelectAll(selectedNode: BaseNode): boolean {
    let atLeastOneItemUnchecked = false;
    if (selectedNode instanceof QueryResultNode) {
      atLeastOneItemUnchecked = this.getStatusAllQueryResultNode(selectedNode, false);
    } else if (selectedNode instanceof QueryFieldsNode) {
      atLeastOneItemUnchecked = this.getStatusAllFieldsNode(selectedNode, false);
    } else if (selectedNode instanceof SimpleSearchListNode) {
      atLeastOneItemUnchecked = this.getStatusSimpleSearchListNode(selectedNode, false);
    }
    return atLeastOneItemUnchecked;
  }

  isQueryResults(): boolean {
    let result = false;
    if (this.selectedNode) {
      result = this.selectedNode.showResults;
    }
    return result;
  }

  isResultList() {
    return this.selectedNode instanceof ResultList;
  }

  isConditionsNode() {
    return this.selectedNode instanceof QueryConditionsNode;
  }

  isMedicinalProductNode() {
    return this.selectedNode instanceof SimpleSearchListNode;
  }


  showRunButton(): boolean {
    return (this.isQueryNode() && !this.isResultNode() && !this.isResultList())
  }

  showRunToExcel(): boolean {
    let node = this.selectedNode;
    if ((!(this.selectedNode instanceof MedicinalProductsQueryNode)) && (this.selectedNode.parent) && (this.selectedNode.parent instanceof MedicinalProductsQueryNode) && (!(this.selectedNode instanceof ResultList))) {
      node = this.selectedNode.parent;
    }
    return node instanceof OwnedAuthorisedProductsQueryNode ||
      node instanceof AuthorisedProductsValidVersionQueryNode ||
      node instanceof AuthorisedProductsLastVersionQueryNode ||
      node instanceof DevelopmentProductsLastVersionQueryNode ||
      node instanceof DevelopmentProductsValidVersionQueryNode ||
      node instanceof OwnedDevelopmentProductsQueryNode ||
      node instanceof ApprovedSubstancesQueryNode ||
      node instanceof DevelopmentSubstanceQueryNode ||
      node instanceof MessageQueryNode ||
      ((node.entityName === 'authorisedProductValidation' && !(node instanceof MedicinalProductsQueryResultNode)) ||
      (node.entityName === 'developmentProductValidation' && !(node instanceof MedicinalProductsQueryResultNode)) || 
      (node.entityName === 'mahvalidation' && !(node instanceof MedicinalProductsQueryResultNode)) || 
      (node.entityName === 'sponsorvalidation' && !(node instanceof MedicinalProductsQueryResultNode)));
  }

  showRemoveItemsMedicinalProductNodeButton() {
    let result = false;
    let children = this.selectedNode.children
    if (children && children.length > 0) {
      result = (!this.isXevprmMessageSimpleSearchChildren()) && 
                (this.isMedicinalProductNode() && 
                 !this.isQueryResults()
                ) || this.isResultList();

      if (result && this.selectedNode instanceof TreeNodeMedicinalProductsXevprmMessage && this.selectedNode.parent != undefined) {
        result = false;
      }
              
    }
    return result;
  }

  showSelectAllButton(): boolean {
    let showResults = false;
    if (this.selectedNode.hasOwnProperty('showResults')) {
      showResults = this.selectedNode.children?.length > 0;
    }
    
    return (!this.isOwnerEVMPDEntities() && !this.isOwnerByEVMPDEntities() && ((this.isMedicinalProductNode() && this.isQueryResults()) || (this.selectedNode instanceof MedicinalProductsQueryResultNode && !(this.selectedNode.parent?.parent instanceof SubstanceNamesQueryNode)) || this.selectedNode instanceof QueryFieldsNode || showResults))
  }

  showDeselectAllButton(): boolean {
    return (this.showSelectAllButton() || this.selectedNode instanceof QueryConditionsNode);
  }

  isXevprmMessageSimpleSearchChildren(): boolean {
    const nodeFound: boolean = Art57NodeUtils.findFirstParentNodeOfType(this.selectedNode, TreeNodeMedicinalProductsXevprmMessage) != null; 
    return nodeFound; 
  }

  isXevprmMessageQueryNode(): boolean {
    const nodeFound: boolean = Art57NodeUtils.findFirstParentNodeOfType(this.selectedNode, MessageQueryNode) != null; 
    return nodeFound; 
  }
  showRemoveButton() {
    return (!this.isXevprmMessageSimpleSearchChildren()) && 
           this.isResultNode() && 
           !this.isAbstractCompositionNode() && 
           !(this.selectedNode.parent instanceof OnDemandAutoUploadNode) &&
           (!(this.selectedNode instanceof TreeNodeMedicinalProductsXevprmMessage) && this.selectedNode.parent != undefined);
  }

  isPaginationAllowed() {
    return this.isResultNode();
  }

  showLoadAllButton(): boolean {
      let showLoadButton4XevprmChildren = (this.selectedNode instanceof XevprmMessageAutoUploadEntity && 
                                           this.selectedNode.parent!.parent != undefined
                                           );
      if (this.selectedNode instanceof XevprmMessageAutoUploadEntity && 
          showLoadButton4XevprmChildren) {
        return true;
      }

    let result =  (this.isMedicinalProductNode() && this.isQueryResults()) ||
      (this.selectedNode instanceof MedicinalProductsQueryResultNode &&
        !(this.selectedNode.parent?.parent instanceof SubstanceNamesQueryNode) &&
        !(this.selectedNode.parent?.parent instanceof OwnedEVMPDEntitiesQueryNode) &&
        !(this.selectedNode.parent?.parent instanceof OwnedByEVMPDEntitiesQueryNode)
      );

      return result;
  }

  showLoadDinamicEntityButton(): boolean {

      if (this.selectedNode instanceof AutoUploadNode && 
          this.selectedNode.parent!.parent instanceof XevprmMessageAutoUploadEntity) {
        return true;
      }

      if (this.selectedNode instanceof SimpleSearchListNode && 
          this.selectedNode.parent instanceof XevprmMessageAutoUploadEntity) {
        return true;
      }

      if (Art57NodeUtils.findFirstParentNodeOfType(this.selectedNode, XevprmMessageAutoUploadEntity) != null) {
        if (this.selectedNode instanceof AuthorisedProductAutoUploadEntity ||
            this.selectedNode instanceof DevelopmentProductAutoUploadEntity) {
          if (this.selectedNode.parent instanceof TreeNodeMedicinalProductsPreviousProductVersion) {
            return false;
          }
        }
      }

    return ((this.selectedNode instanceof AuthorisedProductAutoUploadEntity) ||
      (this.selectedNode instanceof DevelopmentProductAutoUploadEntity)
    ) &&
      (!(this.selectedNode.parent instanceof TreeNodeMedicinalProductsAuthorisedProduct) &&
        !(this.selectedNode.parent instanceof TreeNodeMedicinalProductsDevelopmentProduct)
      ) &&
      (!(this.hideButton()));
  }

  getParentNodeLabel() {
    return Art57NodeUtils.findFirstCurrentOrParentNodeOfType(this.selectedNode, SimpleSearchListNode)?.label;
  }

  showRTFButton() {
    const show = this.isMedicinalProductNode();
    return show;
  }

  showCompare(): boolean {
    return ((this.selectedNode instanceof AuthorisedProductAutoUploadEntity) || (this.selectedNode instanceof DevelopmentProductAutoUploadEntity)) &&
      this.selectedNode.data.model.revision >= 1 &&
      this.selectedNode.data.model.product_nullified === 0 &&
      (this.selectedNode.data.model.ownerhqid === (this.authService.getPrincipal() ? this.authService.getPrincipal().organisation.organisationIdHQ : '') || (this.authService.isEMAOrganisation()));
  }

  showCompareRejected(): boolean {
    return !(this.selectedNode instanceof DevelopmentProductAutoUploadEntity);
  }

  showOperations(): boolean {
    const show = (
      (this.injector.get(SectionService).isAllowedProductReports()) &&
      ((this.selectedNode instanceof AutoUploadNode &&
        this.selectedNode.parent instanceof SimpleSearchListNode
      ) ||
        this.selectedNode instanceof MedicinalProductsQueryResultNode
      ) &&
      // only EMA has access to operations when node is ApprovedSubstanceAutoUploadEntity (with restrictions) 
      (!(this.selectedNode instanceof ApprovedSubstanceAutoUploadEntity) ||
        this.injector.get(AuthService).isEMAOrganisation()
      ) &&
      (!(this.selectedNode instanceof DevelopmentSubstanceAutoUploadEntity) ||
        this.injector.get(AuthService).isEMAOrganisation()
      ) &&
      (!(this.selectedNode instanceof SourceAutoUploadEntity) ||
        this.injector.get(AuthService).isEMAOrganisation()
      ) &&
      (!((this.selectedNode instanceof MedicinalProductsQueryResultNode) &&
        (this.selectedNode.parent!.parent instanceof ApprovedSubstancesQueryNode)) ||
        this.injector.get(AuthService).isEMAOrganisation()
      ) &&
      (!((this.selectedNode instanceof MedicinalProductsQueryResultNode) &&
        (this.selectedNode.parent!.parent instanceof DevelopmentSubstanceQueryNode)) ||
        this.injector.get(AuthService).isEMAOrganisation()
      ) &&
      (!((this.selectedNode instanceof MedicinalProductsQueryResultNode) &&
        (this.selectedNode.parent!.parent instanceof SourceQueryNode)) ||
        this.injector.get(AuthService).isEMAOrganisation()
      ) &&
      (!(this.selectedNode instanceof AttachmentAutoUploadEntity) &&
        !((this.selectedNode instanceof MedicinalProductsQueryResultNode) && (this.selectedNode.parent!.parent instanceof AttachmentQueryNode))
      ) &&
      (!((this.selectedNode instanceof MedicinalProductsQueryResultNode) &&
        (this.selectedNode.parent!.parent instanceof MessageQueryNode))
      )
    ) && !this.isMedicinalProductSimpleQueryNode() && !this.isOwnerEVMPDEntities() && !this.isOwnerByEVMPDEntities() &&

      (
        (!(this.selectedNode instanceof TreeNodeMedicinalProductsAbstractCompositions)) &&
        (!(this.selectedNode instanceof AbstractCompositionsAutoUploadEntity)) &&
        (!(this.selectedNode.parent && this.selectedNode.parent.parent && this.selectedNode.parent.parent instanceof AbstractCompositionQueryNode)) ||
        (this.isValidationQueryNode())
      );

    return show! && (!this.hideButton());
  }

  
  showAssessment(): boolean {
    return this.showProductAssessment() || this.showMahSponsorAssessment();
  }
  
  showProductAssessment(): boolean {
    if (!this.injector.get(AuthService).isAssessmentValidityAllowed()) {
      return false;
    }

    const show = (
      (this.selectedNode instanceof MedicinalProductsQueryResultNode &&
        (this.selectedNode.parent?.parent instanceof AuthorisedProductsLastVersionQueryNode ||
          this.selectedNode.parent?.parent instanceof AuthorisedProductsValidVersionQueryNode ||
          this.selectedNode.parent?.parent instanceof DevelopmentProductsLastVersionQueryNode ||
          this.selectedNode.parent?.parent instanceof DevelopmentProductsValidVersionQueryNode)) ||
      (this.selectedNode instanceof AuthorisedProductAutoUploadEntity ||
        this.selectedNode instanceof DevelopmentProductAutoUploadEntity) ||
      (this.selectedNode.entityName === 'authorisedProductValidation' ||
        this.selectedNode.entityName === 'developmentProductValidation')
    )
    return show;
  }

  showMahSponsorAssessment(): boolean {
    if (!this.injector.get(AuthService).isAssessmentValidityAllowed()) {
      return false;
    }

    const show = 
      (this.selectedNode instanceof MedicinalProductsQueryResultNode &&
        (this.selectedNode.parent?.parent instanceof MAHsQueryNode ||
        this.selectedNode.parent?.parent instanceof SponsorQueryNode)) ||
        (this.selectedNode instanceof MAHAutoUploadEntity ||
        this.selectedNode instanceof SponsorAutoUploadEntity) || 
        (this.selectedNode.entityName === 'mahvalidation' ||
        this.selectedNode.entityName === 'sponsorvalidation');

    return show;
  }

  isAutoUploadNode(): boolean {
    return (this.selectedNode instanceof AutoUploadNode) &&
      (this.selectedNode.parent != undefined) &&
      (this.selectedNode.parent instanceof SimpleSearchListNode) &&
      (!(this.selectedNode.parent instanceof TreeNodeMedicinalProductsAbstractCompositions));
  }

  export(selectedNode: any, multiple: boolean, format: string) {
    let entityName = selectedNode['entityName'];
    let data: any[] = [];
    let onDemandEntities: any[] = [];
    if ((this.isMedicinalProductNode() && this.isQueryResults()) || (this.isResultNode() && (!this.isAbstractCompositionQuery()) && (!this.isAbstractCompositionNode()))) {
      data = this.selectedNode.data.model.filter((i: any) => i.checked && i.checked === true).map((i: any) => i.id);
    } else if (this.isMedicinalProductNode() && !this.isQueryResults()) {
      data = this.selectedNode.children.filter((i: any) => i.checked && i.checked === true).map((i: any) => i.code)
    } else if (this.isAbstractCompositionQuery()) {
      onDemandEntities = this.selectedNode.data.model.filter((i:any) => i.checked && i.checked == true);
      data = onDemandEntities.map((i:any)=>i.id);
    }

    if (this.isAutoUploadNode()) {
      data.push(this.selectedNode.code)
      entityName = selectedNode['autoUploadEntityName'];
    } else if (this.selectedNode instanceof AbstractCompositionsAutoUploadEntity) {
      data.push(this.selectedNode.code) 
      entityName = 'abstractCompositionsSearch';
    }

    if (this.selectedNode instanceof OnDemandAutoUploadNode ||
      this.selectedNode instanceof OnDemandSimpleSearchListNode
    ) {
      if (this.selectedNode instanceof OnDemandAutoUploadNode) {
        onDemandEntities = { ...[this.selectedNode.getOnDemandEntities()] };
      } else {
        onDemandEntities = { ...this.selectedNode.getOnDemandEntities() };
      }
    }

    this.getExportedRecords(entityName, data, onDemandEntities, multiple, format);
  }

  isModalOpen = false;

  compare(selectedNode: any, compareType: 'PREVIOUS' | 'LAST' | 'VALID' | 'REJECTED' | 'FIRST' | 'NEXT' | 'PENDING') {

    
    const messageMap: any = {
      PREVIOUS: 'Comparing current version to previous version',
      LAST: 'Comparing current version to last version',
      VALID: 'Comparing current version to valid version',
      REJECTED: 'Comparing current version to rejected version',
      FIRST: 'Comparing current version to first version',
      NEXT: 'Comparing current version to next version',
      PENDING: 'Comparig current version to pending version'

    };


    this.injector!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: messageMap[compareType], life: environment.successElapsedTime });
    if (selectedNode.data != undefined && selectedNode.data.model.id) {
      this.injector!.get(MedicinalproductsService).compare(selectedNode.autoUploadEntityName, selectedNode.data.model.id,compareType)
        
.subscribe({
  next: (diffs: any) => {

    if (!diffs) {
      this.showCompareError(compareType);
      return;
    }

    if (this.isModalOpen) return;
    this.isModalOpen = true;

    this.modalRef = this.modalService.show(DiffViewerComponent, {
      initialState: { diffs }
    });

    this.modalRef.onHidden!.subscribe(() => {
      this.isModalOpen = false;
    });
  },

  error: () => {
    this.showCompareError(compareType);
  }
});

    }
  }

  showCompareError(compareType: string) {

    
let message = '';

  switch (compareType) {
    case 'NEXT':
      message = 'No next version available to compare';
      break;
    case 'REJECTED':
      message = 'No rejected version available to compare';
      break;
    case 'PENDING':
      message = 'No pending version available to compare';
      break;
    case 'VALID':
      message = 'No valid version available to compare';
      break;
    case 'LAST':
      message = 'No last version available to compare';
      break;
    case 'PREVIOUS':
      message = 'No previous version available to compare';
      break;
    case 'FIRST':
      message = 'No first version available to compare';
      break;
    default:
      message = 'Comparison not available';
  }

  this.injector!.get(Art57Section).showTooltipMessage({
    severity: 'warn',
    detail: message,
    life: environment.errorElapsedTime
  });


  }

  getExportedRecords(entityName: string, data: any, onDemandEntities: any, multiple: boolean, format: string) {

    if (data != undefined && data.length > 0) {
      this.injector!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: `Exporting records to ${new String(format).toUpperCase()} file...`, life: environment.successElapsedTime });
      this.injector!.get(MedicinalproductsService).exportResults(entityName, data, onDemandEntities, multiple, format)
        .subscribe((response: any) => {
          const contentDisposition = response.headers.get('content-disposition');
          const filename = contentDisposition.match(/filename=(.+)$/)[1].replace(/['"]/, '').trim();
          const url = window.URL.createObjectURL(response.body as Blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          this.injector!.get(Art57Section).showTooltipMessage({ severity: 'success', detail: `Exporting records to ${new String(format).toUpperCase()} finished. You can retrieve your file in your browser’s Downloads folder`, life: environment.successElapsedTime });
        }, (error: any) => {
          this.injector!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
        });
    } else {
      this.injector!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: `Exporting records to ${new String(format).toUpperCase()} finished - No element has been selected`, life: environment.warningElapsedTime });
    }
  }

  showXMLButton() {
    const show = this.isMedicinalProductNode() &&
      ((!(this.selectedNode instanceof TreeNodeMedicinalProductsAbstractCompositions)) &&
        (!(this.selectedNode instanceof AbstractCompositionsAutoUploadEntity) &&
          (!(this.selectedNode.parent && this.selectedNode.parent.parent && this.selectedNode.parent.parent instanceof AbstractCompositionQueryNode))));
    return show;
  }

  showReinsert() {
    return (!(this.selectedNode instanceof ApprovedSubstanceAutoUploadEntity));
  }

  showInvalidateMA() {
    return ((this.selectedNode.parent &&
      this.selectedNode.parent instanceof TreeNodeMedicinalProductsAuthorisedProduct
    ) ||
      (this.selectedNode.parent && this.selectedNode.parent.parent &&
        (this.selectedNode.parent.parent instanceof AuthorisedProductsValidVersionQueryNode ||
          this.selectedNode.parent.parent instanceof AuthorisedProductsLastVersionQueryNode ||
          this.selectedNode.parent.parent instanceof OwnedAuthorisedProductsQueryNode)
      )
    );
  }

  isMedicinalProductSimpleQueryNode() {
    return this.selectedNode instanceof MedicinalProductsSimpleQueryNode;
  }

  showModify() {
    return this.isResultNode() && !this.isMedicinalProductSimpleQueryNode() && !this.isOwnerEVMPDEntities() && !this.isAbstractCompositionNode();
  }

  hideButton() {
    return (this.selectedNode instanceof XevprmMessageAutoUploadEntity) ||
           (this.selectedNode instanceof TreeNodeMedicinalProductsXevprmMessage) ||
           (this.selectedNode instanceof SimpleSearchListNode && this.selectedNode.parent && this.selectedNode.parent instanceof XevprmMessageAutoUploadEntity);
  }

  showExport() {
    const show = this.isResultNode() && !this.isAbstractCompositionQuery() && !this.isAbstractCompositionNode() && !this.hideButton();
    return show;
  }

  isOwnerEVMPDEntities() {
    return ((this.selectedNode.entityName == "ownerEVMPDEntities") || (this.selectedNode.parent && (this.selectedNode.parent.parent instanceof OwnedEVMPDEntitiesQueryNode)));
  }

  isOwnerByEVMPDEntities() {
    return ((this.selectedNode.entityName == "ownerByEVMPDEntities") || (this.selectedNode.parent && (this.selectedNode.parent.parent instanceof OwnedByEVMPDEntitiesQueryNode)));
  }

  showSectionExport() {
    const show = !(this.isOwnerByEVMPDEntities() || this.isOwnerEVMPDEntities() || this.isAbstractCompositionQuery() || this.isAbstractCompositionNode() || this.isXevprmMessageQueryNode()) 
    return show;
  }

  showSortButton() {
    return this.selectedNode instanceof QueryFieldsNode || this.isConditionsNode();
  }

  isValidationQueryNode(){
    if (this.selectedNode instanceof MedicinalProductsQueryResultNode) {
      return (this.selectedNode.parent && this.selectedNode.parent.parent && this.selectedNode.parent.parent.parent && this.selectedNode.parent.parent.parent instanceof ValidationQueryNode);
    }
    return (this.selectedNode.parent && this.selectedNode.parent.parent && this.selectedNode.parent.parent instanceof ValidationQueryNode);
  }

  sortField(selectedNode: BaseNode) {
    selectedNode.data.fields.sort((a: any, b: any) => {
      let labelA = a.props["label"] || '';
      let labelB = b.props["label"] || '';

      return this.sortOrder ? labelA.localeCompare(labelB) : labelB.localeCompare(labelA);
    });

    this.sortOrder = !this.sortOrder;
    selectedNode.data.fields = [...selectedNode.data.fields];
  }

  assess(selectedNode: any, type: string) {
    const isArrayModel = Array.isArray(this.selectedNode.data.model);
    const art57 = this.injector.get(Art57Section);

    const entityName = isArrayModel
      ? selectedNode.parent.parent['autoUploadEntityName']
      : selectedNode['autoUploadEntityName'];

    const originalList = isArrayModel
      ? this.selectedNode.data.model.filter((i: any) => i.checked === true)
      : [this.selectedNode.data.model];

    if (!this.hasSelectedItems(originalList)) {
      return;
    }

    
    const typeEntity: string = this.getTypeEntity(entityName);
    const typeEntityLabel:  string = this.getTypeEntityLabel(typeEntity);
    const config = this.getAssessConfig(typeEntityLabel, type);
    const finalList = this.getFinalAssessList(originalList, typeEntity, config.operation);
    const finalCodes = new Set(finalList.map((item:any) => item.ev_Code));
    const rejectList =  originalList.filter((item: any) => !finalCodes.has(item.ev_Code));


    //Return warn message with ev_code of item rejected
    if (rejectList) {
      rejectList.forEach((i: any) => {
        art57.showTooltipMessage({
          severity: 'warn',
          detail: `${config.operationNotAllowed} ${i.ev_Code}`,
          life: environment.warningElapsedTime
        });
      })

    }

    if (finalList.length > 0) {
        this.requestAssess(finalList, rejectList, entityName, type, config);
    }
        
  }

  // Check if any item is selected
  private hasSelectedItems(originalList: any[]): boolean {
    if (!originalList.length) {
      this.injector.get(Art57Section).showTooltipMessage({
        severity: 'warn',
        detail: 'No items selected',
        life: environment.warningElapsedTime
      });
      return false;
    }

    return true;
  }

  //Get the common type of each entity, for comparying logic
  //product, organisation...
  private getTypeEntity(entityName: any): string{
    return TYPE_DICTIONARY[entityName];
  }

  //Get the common entity label for each entity, for displaying in the labels, messages
  private getTypeEntityLabel(entityType: string): string {
    return TYPE_DICTIONARY_LABEL[entityType];
  }
  
  //Config the assesment according to the type
  private getAssessConfig(typeEntityLabel: string, type: string) {
    const start = '<p>The command will flag as';
    const end = 'OK to proceed?';
    const operationNotAllowed = 'The operation cannot be performed on entity with EV Code';
    const successClearVal = typeEntityLabel + ' validity successfully cleared';

    const configs: Record<string, any> = {
      val: {
        operation: 0,
        message: `${start} Valid the selected ${typeEntityLabel.toLowerCase()}.
        
        ${end}</p>`,
        success: `The selected ${typeEntityLabel.toLowerCase()} were successfully flagged as Valid`,
        successPartially: `${typeEntityLabel} successfully validated as requested`,
        operationNotAllowed: operationNotAllowed
      },
      clearVal: {
        operation: 1,
        message: `${start} Not Assessed the selected ${typeEntityLabel.toLowerCase()}.
        
        ${end}</p> `,
        success: successClearVal,
        successPartially: successClearVal,
        operationNotAllowed: operationNotAllowed
      }
    };

    return configs[type];
  }

  // Get the final list to assess, the entities must meet BRs for assessing
  // Product -> evaluating fields: 
  //    - product_version_validity
  //    - product_version_status
  // Organisation -> evaluating fields:
  //    - validated
  //    - stamp_nullif
  private getFinalAssessList(originalList: any[], typeEntity: string, operation: number): any[] {
    switch (typeEntity) {
      case 'product':
        var finalList = originalList.filter(
          (i: any) =>
          {

            if (operation===1){  //Clear valid
                return (i['stamp_nullif'] === null || i['stamp_nullif'] === '' || i['product_nullified']===0) &&  (i['product_version_validity'] === 1 || i['version'].includes('Valid'));
            }else{  //Valid
                return (i['stamp_nullif'] === null || i['stamp_nullif'] === '' || i['product_nullified']===0) &&  (i['product_version_validity'] === 0 || (!i['version'].includes('Valid')));
            }

          }
        );
        return finalList;

      case 'organisation': {
        const finalList = originalList.filter(
          (i: any) =>
            (i['validated'] === null || i['validated'] === '') &&
            (i['stamp_nullif'] === null || i['stamp_nullif'] === '')
        );

        if (this.selectedNode?.code !== undefined) {
          return finalList.map((item: any) => ({
            ...item,
            id: this.selectedNode.code
          }));
        }

        return finalList;
      }

      default:
        return [];
    }
  }


  private requestAssess(
    finalList: any[],
    rejectList: any[],
    entityName: string,
    assessType: string,
    config: any
  ) {
    const confirmationService = this.injector.get(ConfirmationService);
    const service = this.injector.get(MedicinalproductsService);
    const art57 = this.injector.get(Art57Section);

    let message = config.message;

    confirmationService.confirm({
      header: 'Message from webpage',
      message,
      icon: 'pi pi-question-circle',
      acceptLabel: 'Ok',
      rejectLabel: 'Cancel',
      accept: () => {
        service.loading.next(true);

        service.assess(entityName, assessType, finalList.map(i => i.id))
          .subscribe({
            next: (response: AssessmentResultSummaryInfo) => {
              service.loading.next(false);

              if (assessType === 'val' && response?.fileBytes && response?.fileName) {
                this.downloadBase64File(response);
              }

              setTimeout(() => {
                this.handlePostSuccess(response, assessType);
              }, 100);

              setTimeout(() => {
                this.handleAssessmentMessages(response, art57, rejectList, config);
              }, 300);

            },
            error: () => {
              service.loading.next(false);
            }
          });
      }
    });
  }

  private handleAssessmentMessages(
    response: AssessmentResultSummaryInfo,
    art57: any,
    rejectList: any[],
    config: any
  ): void {
    
    if (!response?.resultInfoList?.length) {
      return;
    }

    if (rejectList.length == 0 && this.allResultsSuccessful(response)) {
      art57.showTooltipMessage({
        severity: 'success',
        detail: config.success,
        life: environment.successElapsedTime
      });

      return;
    }

    const successItems = response.resultInfoList.filter(item => item.resultStatus === 'ok');
    const failedItems = response.resultInfoList.filter(item => item.resultStatus !== 'ok');

    failedItems.forEach(item => {
      art57.showTooltipMessage({
        severity: 'warn',
        detail: `${config.operationNotAllowed} ${item.evCode}`,
        life: environment.warningElapsedTime
      });
    });

    if ((rejectList.length > 0 || failedItems.length > 0) && successItems.length > 0) {
      art57.showTooltipMessage({
        severity: 'success',
        detail: config.successPartially,
        life: environment.successElapsedTime
      });
    }
  }

  private allResultsSuccessful(response: AssessmentResultSummaryInfo): boolean {
    return !!response?.resultInfoList?.length &&
      response.resultInfoList.every(item => item.resultStatus === 'ok');
  }

  private downloadBase64File(response: AssessmentResultSummaryInfo): void {
    if (!response.fileBytes || !response.fileName) {
      return;
    }

    const byteCharacters = atob(response.fileBytes);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob(
      [byteArray],
      { type: response.fileContentType || 'application/octet-stream' }
    );

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.href = url;
    a.download = response.fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  //Reload the records
  private handlePostSuccess(response: AssessmentResultSummaryInfo, assessType: any) {
    if (this.selectedNode.isLoaded) {
      const entityAssessmentSuccessful = !response?.resultInfoList?.some(item => item.resultStatus === 'err');
      if (entityAssessmentSuccessful) {
        this.selectedNode.reloadEntity();
      }
      return;
    }

    this.injector.get(ConfirmationService).confirm({
      header: 'Message from webpage',
      message: '<p>Click Ok if you want to rerun the Query.</p><p>If you choose not to rerun the query, the displayed results will not contain the latest changes.</p>',
      icon: 'pi pi-question-circle',
      acceptLabel: 'OK',
      rejectLabel: 'Cancel',
      accept: () => {
        this.injector.get(MedicinalProductComponent)
          .onReRunQuery(this.selectedNode);
      },
      reject: () => {
        const isProduct = this.selectedNode.data.model[0].ev_Code.includes('PRD');
        if (isProduct) {
          this.selectedNode.data.model = this.selectedNode.data.model.map((item: any) => {
            const result = response!.resultInfoList!.some(
              result => result.evCode === item.ev_Code && result.resultStatus === 'ok'
            );
            if (result) {
              if (assessType === 'val') {
                return {
                  ...item,
                  version: `${item.revision}/${item.revision} Valid`,
                };
              } else {
                return {
                  ...item,
                  version: `${item.revision}/${item.revision}`,
                };
              }
            }
            return item;
          });
        }
      }
    });
  }

  showRefreshButton() {
    const showbutton = (this.isMedicinalProductNode()  && 
                        !(this.selectedNode instanceof TreeNodeMedicinalProductsXevprmMessage) &&
                        !(this.selectedNode.parent instanceof OnDemandAutoUploadNode)
                        );

    if (!showbutton){
      return (this.selectedNode instanceof TreeNodeMedicinalProductsXevprmMessage && 
             this.selectedNode.parent == undefined);
    }
    return showbutton;
  }

  isXevprmMessageSimpleSearch(): boolean { 
    const nodeBelongsToxevprmMessage: boolean = Art57NodeUtils.findFirstCurrentOrParentNodeOfType(this.selectedNode, TreeNodeMedicinalProductsXevprmMessage) != null; 
    return nodeBelongsToxevprmMessage; 
  } 

  onPageSizeSelected(item: { label: string; value: number }, event: MouseEvent): void {
    event.preventDefault();
    this.selectedNode.selectedPageSize = item.value;
  }

  isLoading() {
    return this.injector.get(MedicinalproductsService).loading.value;
  }
}
